import { CHANGE_COLLAPSE } from "./constants";

const actions = {
    [CHANGE_COLLAPSE]({commit}){
        commit(CHANGE_COLLAPSE)
    }
}

export default actions